import Article, {ArticleType} from "../../api/model/Article";
import Tag from "../shared/Tag/Tag";
import {Config} from "../../config";
import React, {useEffect, useState} from "react";
import ArticleApi from "../../api/ArticleApi";
import moment from "moment"
import "./ArticleCard.scss"

export default function ArticleCard(props: IProps) {

    const [list, setList] = useState<Article[]>([]);

    async function listArticle() {
        const response = await ArticleApi.search({
            pi: 1,
            ps: 5,
            type: props.type
        });
        setList(response.list)
    }

    useEffect(() => {
        listArticle();
    }, [listArticle]);

    const sortedList = list.sort(i => i.isTop ? -1 : 1);


    return (
        <div className="ArticleCard">
            <div className="header">
                <span className="title">{props.type}</span>
                <div className="more" onClick={() => {
                    props.onNavigateToList && props.onNavigateToList();
                }}>
                    查看更多
                </div>
            </div>
            <div className="body">
                {sortedList.map((item, index) => (
                    <div key={item.id} className="article-line" onClick={() => {
                        props.onNavigateToDetail && props.onNavigateToDetail(item.id);
                    }}>
                        {index === 0 && (
                            <div className="first-line">
                                <div className="calendar">
                                    <div className="month">{moment(item.createdTime).format('YYYY-MM')}</div>
                                    <div className="date">{moment(item.createdTime).format('DD')}</div>
                                </div>
                                <div className="first-line-body">
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                                        {item.isTop && <div className="tag">
                                            <Tag text="置顶" color={Config.secondaryColor} textColor="#fff"
                                                 style={{width: 25, display: "inline-flex"}}/>
                                        </div>}
                                        <span>{item.title}</span>
                                    </div>
                                    <span className="description">
                                            {item.description}
                                        </span>
                                </div>
                            </div>
                        )}
                        {index !== 0 && (
                            <div className="normal-line">
                                <div>
                                    {item.isTop && <div className="tag">
                                        <Tag text="置顶" color={Config.secondaryColor} textColor="#fff"/>
                                    </div>}
                                    <span className="title">{item.title}</span>
                                </div>
                                <span className="createdTime">{moment(item.createdTime).format('YYYY-MM-DD')}</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>

    )
}

interface IProps {
    type: ArticleType;
    onNavigateToList?: () => any;
    onNavigateToDetail?: (id: number) => any;
}
